import { createAction } from 'redux-actions'

const SET_NUMBER_OF_TRIPS = 'SET_NUMBER_OF_TRIPS'
const setNumberOfTrips = createAction(SET_NUMBER_OF_TRIPS)

function numberOfTrips(state = 0, {
  type,
  payload,
}) {
  switch (type) {
    case SET_NUMBER_OF_TRIPS:
      return payload
    default:
      return state
  }
}

export {
  setNumberOfTrips,
  numberOfTrips,
}
